<template>
    <main class="content page books">
        <div v-if="page" :class="!loading ? '' : 'loading'">
            <!--<hero :page="page"></hero>-->
            <section class="pageHero">
                <div class="container">
                    <div class="img" :style="{ backgroundImage: `url(${ featuredImage })` }" v-if="page.image"></div>
                    <div class="hero-content">
                        <h2 v-html="page.hero.title"></h2>
                        <div v-html="page.hero.lead"></div>
                    </div>
                </div>
            </section>
            <section v-if="page.ordering.locations" class="ordering">
                <div class="container">
                    <h2 v-html="page.ordering.title"></h2>
                    <ul>
                        <li v-for="location in page.ordering.locations">
                            <a :href="location.url" target="_blank" rel="noopener noreferrer"><img :src="location.logo" :alt="location.name" /></a>
                        </li>
                    </ul>
                    <p v-html="page.ordering.inquiries"></p>
                </div>
            </section>
            <section v-if="page.praise.comments" class="praise">
                <div class="container">
                    <div>
                        <div class="circleHeader">
                            <h2 v-html="page.praise.title"></h2>
                        </div>
                        <blockquote v-for="(comment, i) in page.praise.comments" :key="i">
                            <span v-html="comment.quote"></span>
                            <footer v-if="comment.attribution"><cite>&mdash; {{ comment.attribution }}</cite></footer>
                        </blockquote>
                    </div>
                    <div class="img" v-if="page.praise.image" :style="{backgroundImage: `url(${page.praise.image.sizes.medium})`}"></div>
                </div>
            </section>
            <section v-if="page.other_books.books" class="other-books">
                <div class="container">
                    <div>
                        <div class="circleHeader">
                            <h2 v-html="page.other_books.title"></h2>
                        </div>
                        <div class="the-books">
                            <div class="book" v-for="book in page.other_books.books">
                                <div class="cover dotTop">
                                    <a :href="book.url" target="_blank" rel="noopener noreferrer"><img :src="book.image.sizes.medium" :alt="book.title" /></a>
                                </div>
                                <div class="details">
                                    <h3 class="title">
                                        <a :href="book.url" target="_blank" rel="noopener noreferrer" v-html="book.title"></a>
                                    </h3>
                                    <p class="description" v-html="book.description"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </main>
</template>

<script>
    export default {
      name: 'books',
      data () {
        return {
          loading: true,
          page: null
        }
      },
      mounted () {
        this.fetchPost()
      },
      methods: {
        fetchPost () {
          let vm = this
          vm.$axios.get('/posts', {
            params: {
              slug: 'books'
            }
          }).then((response) => {
            vm.page = response.data
            process.nextTick(() => {
              vm.loading = false
              if (vm.$route.hash) vm.scrollToAnchor()
            })
          }).catch((err) => {
            vm.loading = false
            console.log(err)
          })
        },
        scrollToAnchor () {
          let id = this.$route.hash.replace('#', '')
          process.nextTick(() => {
            document.getElementById(id).scrollIntoView()
          })
        }
      },
      computed: {
        featuredImage () {
          let vm = this
          if (vm.page && vm.page.image) {
            let image = vm.page.image.large
            if (process.env.NODE_ENV === 'development') {
              image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content')
            }
            return image
          }
        }
      }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
    @import ../assets/styles/colors
    @import ../assets/styles/mixins

    section
      &.pageHero
        .img
          border: none
          background-color: transparent
          background-size: contain
          background-repeat: no-repeat
          border-radius: 0
          +tablet
            top: 50px

      &.ordering
        background: $white
        padding: 1px 50px 50px
        h2
          font-size: 32px
          line-height: 36px
          font-weight: bold
          letter-spacing: 0.2px
          margin-bottom: 30px
          margin-top: 0
          text-align: center
          +tablet
            font-size: 36px
            line-height: 46px
        ul
          list-style: none
          li
            margin-top: 2em
            margin-bottom: 2em
            border: solid 1px $grey
            border-radius: 10px
            text-align: center
            &:hover
              box-shadow: 1px 1px 35px -10px $grey
          +tablet
            display: flex
            flex-wrap: nowrap
            align-items: center
            justify-content: space-between
            li
              margin-top: 0
              flex-basis: 30%;
        p
          font-size: 20px
          text-align: center

      &.praise
        background: $turquoise
        padding-top: 84px
        padding-bottom: 60px
        .container
          +tablet
            display: flex
          > div
            &:first-child
              flex: 1
        .circleHeader
          &:before
            background: $white
        .img
          width: 300px
          height: 300px
          border-radius: 50%
          border: 8px solid #fff
          background: $body-background
          background-size: cover
          background-position: center center
          +until($tablet)
            margin-top: 30px
          +tablet
            margin-left: 40px
            position: relative
            top: -20px
            width: 320px
            height: 320px
        blockquote
          margin-bottom: 15px
          border: none
          font-size: 20px
          &:last-child
            margin-bottom: 0
          &:before
            color: $white
            content: "“"
            display: block
            font: 400%/1 Georgia,"Times New Roman", serif
            height: 0
          span
            margin-left: 45px
            display: inline-block
          footer
            margin-left: 45px

      &.other-books
        padding-top: 50px
        padding-bottom: 58px
        .circleHeader
          &:before
            background: $yellow
        .dotTop
          margin: 0
          &:before
            margin: 2rem auto
            background-color: $yellow
        .book
          text-align: center
          &:first-child
            .dotTop:before
              margin: 0
              background-color: transparent
          .cover
            img
              max-height: 300px
          .details
            display: none
          +smTablet
            text-align: left
            display: flex
            justify-content: center
            .dotTop
              &:before
                margin: 0
                background-color: transparent
                height: 0
            div
                flex-basis: auto
                &.cover
                    margin-right: 30px
                    margin-bottom: 30px
                &.details
                    width: 65%
                    display: block
                    .title
                        font-weight: 600
                    .description
                        font-size: 1.35em

</style>



// WEBPACK FOOTER //
// Books.vue?6d2b3305